export enum ImportExistingEmailAddressType {
    Undefined = 0,
    Ignore = 1,
    Add = 2,
    Update = 3
}
